
export const Roles = {
    witness: "Witness",
    csr: "CSR",
    admin: "Admin",
    sandbox: "Sandbox",
    globalAdmin: "GlobalAdmin",
    profile: "Profile",
    guest: "Guest",

    getAllRoles() {
        return [Roles.admin, Roles.globalAdmin, Roles.csr, Roles.profile, Roles.sandbox, Roles.witness, Roles.guest];
    }
}

export const RoleValueWitness =
    [

        "BusinessUnitRead",

        "AccountManagement",
        "AccountCreate",
        "AccountRead",
        "AccountUpdate",

        "ClientCreate",
        "ClientManagement",
        "ClientRead",
        "ClientUpdate",

        "RequisitionAddNewFile",
        "RequisitionSubmit",
        "RequisitionDelete",
        "RequisitionUpdate",
        "RequisitionCreate",
        "RequisitionManagement",
        "RequisitionReadLimitedToOwner",

        "TimeLineManagement",
        "TimeLineRead",
        "TimeLineCreateNote",

        "UserReadLimitedToOwner",

        "EmailManagement",
        "SendEmailTemplate",
        "EmailTemplateRead",

        "Dashboards",
        "DashboardEcommerce",

        "FileReadAll",
        "FileCreate",
        "FileDelete",
        "FileCustomPermissions",
        "FileManager",

        "TaskCreate",
        "TaskReadLimitedToOwner",

        "Marketplace",
        "Explore",

        "InvoiceReadLimitedToOwner",
        "InvoiceReadBillingHistory"

    ]
export const RoleValueCSR =
    [
        "BusinessUnitManagement",
        "BusinessUnitRead",

        "AccountCreate",
        "AccountManagement",
        "AccountRead",
        "AccountUpdate",

        "ClientCreate",
        "ClientManagement",
        "ClientRead",
        "ClientReadAll",
        "ClientUpdate",

        "RequisitionAddNewFile",
        "RequisitionComplete",
        "RequisitionCreateCheque",
        "RequisitionCreateInvoice",
        "RequisitionCreatePayment",
        "RequisitionDelete",
        "RequisitionIncomplete",
        "RequisitionManagement",
        "RequisitionProcess",
        "RequisitionReadAll",
        "RequisitionRefundPayment",
        "RequisitionReject",
        "RequisitionUpdate",
        "RequisitionUpdatePrice",
        "RequisitionViewPayment",

        "EmailManagement",
        "EmailTemplateCreate",
        "EmailTemplateRead",
        "EmailTemplateUpdate",

        "SendEmail",
        "SendEmailTemplate",
        "TimeLineCreateEmail",
        "TimeLineCreateNote",
        "TimeLineManagement",
        "TimeLineRead",

        "UserRead",

        "DashboardCsr",
        "DashboardEcommerce",
        "Dashboards",

        "JobManagement",
        "JobCreate",
        "JobDelete",
        "JobReadLimitedToOwner",

        "FileReadAll",
        "FileCreate",
        "FileDelete",
        "FileCustomPermissions",
        "FileManager",

        "TaskCreate",
        "TaskReadLimitedToOwner",
        "TaskDelete",
        "TaskUpdate",
    ]
export const RoleValueAdmin =
    [
        "BusinessUnitManagement",
        "BusinessUnitRead",

        "AccountManagement",
        "AccountCreate",
        "AccountRead",
        "AccountUpdate",

        "ClientCreate",
        "ClientManagement",
        "ClientRead",
        "ClientReadAll",
        "ClientDelete",
        "ClientUpdate",

        "RequisitionManagement",
        "RequisitionRefundPayment",
        "RequisitionAddNewFile",
        "RequisitionReadAll",
        "RequisitionUpdatePrice",
        "RequisitionCreatePayment",
        "RequisitionCreateCheque",
        "RequisitionCreateInvoice",
        "RequisitionIncomplete",
        "RequisitionComplete",
        "RequisitionProcess",
        "RequisitionReject",
        "RequisitionDelete",
        "RequisitionUpdate",
        "RequisitionSubmit",
        "RequisitionCreate",
        "RequisitionViewPayment",
        "RequisitionDeleteInvoice",
        "RequisitionDeleteCheque",

        "TimeLineManagement",
        "TimeLineRead",
        "TimeLineCreateNote",
        "TimeLineCreateEmail",

        "OperationManagement",
        "OperationRead",
        "AuthorizationContextCreate",
        "AuthorizationContextRead",
        "AuthorizationContextUpdate",

        "UserManagement",
        "UserCreate",
        "UserReadAll",
        "UserUpdate",

        "ApiKeysManagement",
        "ApiKeyCreate",

        "EmailManagement",
        "SendEmailTemplate",
        "EmailTemplateCreate",
        "EmailTemplateUpdate",
        "SendEmail",
        "EmailTemplateRead",

        "Dashboards",
        "DashboardEcommerce",
        "DashboardCsr",
        "DashboardAnalytics",
        "DashboardProject"
    ]
export const RoleValueProfile =
    [
        "BusinessUnitRead",

        "TimeLineManagement",
        "TimeLineReadLimitedToOwner",

        "UserReadLimitedToOwner",

        "RequisitionReadLimitedToOwner",
        "Dashboards",
        "FileReadLimitedToOwner",
        "FileCreate",
        "FileCustomPermissions",
        "FileManager",

        "TaskCreate",
        "TaskReadLimitedToOwner",
    ]
export const RoleValueSandbox =
    [
        "BusinessUnitRead",
        
        "AccountManagement",
        "AccountCreate",
        "AccountRead",
        "AccountUpdate",
        "AccountReadLimitedToOwner",

        "ClientCreate",
        "ClientManagement",
        "ClientRead",
        "ClientUpdate",
        "ClientReadLimitedToOwner",

        "RequisitionAddNewFile",
        "RequisitionSubmit",
        "RequisitionDelete",
        "RequisitionUpdate",
        "RequisitionCreate",
        "RequisitionManagement",
        "RequisitionReadLimitedToOwner",

        "TimeLineManagement",
        "TimeLineReadLimitedToOwner",
        "TimeLineCreateNote",

        "UserReadLimitedToOwner",

        "EmailManagement",
        "SendEmailTemplate",
        "EmailTemplateRead",

        "Dashboards",
        "DashboardEcommerce",

        "FileReadLimitedToOwner",
        "FileCreate",
        "FileCustomPermissions",
        "FileManager",

        "TaskCreate",
        "TaskReadLimitedToOwner",

        "Marketplace",
        "Explore",

        "InvoiceReadLimitedToOwner",
        "InvoiceReadBillingHistory"
    ]
